<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="stats"
      y-value-prefix="stats."
      x-value="date"
      :chart-value-keys="chartValueKeys"
      :yaxis="yAxisConfig"
      :colors="['#26E18E', '#F62424']"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.team_mood_stress') }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.team_mood_stress') }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <chart-list-view-table
        :headers="tableHeaders"
        :items="stats"
      >
        <template v-slot:item.date="{ item }">
          {{ formatDate(item.date) }}
        </template>
      </chart-list-view-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import dayjs from 'dayjs'
import ChartListViewTable from '@/components/charts/implementation/ChartListViewTable.vue'

export default {
  name: 'TeamMoodStressTrendChart',
  components: { ChartListViewTable, LineChart, VisualListToggle },
  props: {
    stats: {
      type: Array,
      required: true,
      default: () => []
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      return [
        {
          key: 'MOO',
          label: this.$t('variables.MOO.long'),
          type: 'line'
        },
        {
          key: 'STL',
          label: this.$t('variables.STL.long'),
          type: 'line'
        }
      ]
    },
    yAxisConfig() {
      return [
        {
          min: 0,
          max: 5,
          title: { text: this.$t('variables.MOO.long') },
          seriesName: 'MOO'
        },
        {
          min: 0,
          max: 5,
          title: { text: this.$t('variables.STL.long') },
          seriesName: 'STL',
          opposite: true
        }
      ]
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.date'),
          value: 'date',
          sortable: true,
          width: '20%'
        },
        {
          text: this.$t('variables.MOO.long'),
          value: 'stats.MOO',
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('variables.STL.long'),
          value: 'stats.STL',
          sortable: true,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('ll')
    }
  }
}
</script>
